import MenuIcon from '@mui/icons-material/Menu';
import {
  AppBar,
  Avatar,
  Box,
  Badge,
  Container,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  Toolbar,
  Typography,
  useMediaQuery,
  ListItemText,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import NotificationsIcon from '@mui/icons-material/Notifications';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import HistoryIcon from '@mui/icons-material/History';
import LoginIcon from '@mui/icons-material/Login';
import LockIcon from '@mui/icons-material/Lock';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { authAtom, userInformationAtom } from '../../Services/_states';
import { useRecoilState, useSetRecoilState } from 'recoil';
// import SideNavBar from "../Sidebar/sideBar";
import { ConstantActions } from "../../Services/_actions";
import { globalpermissions } from "../../Services/Permission";
import ModernSidebar from "../Sidebar/ModernSidebar.tsx";
import { useChatSocket } from "../../WebSockets/ChatSocket.ts";
import { storeNotification } from '../../utils/notificationStorage.ts';
import MachadaloLogo from './machadalo-logo.png';
import MachadaloLogoTop from './header-machadalo-logo.png';
import TestLogo from './synergytop-logo.webp';
import { leadsActionSelector } from '../../Services/_states/Leads/leadSelector.ts';
import { useWebSocketAiContext } from '../../utils/WebSocketContext.tsx';
import { LoginActions } from '../../Services/_actions/LoginAction/LoginAction.ts';
import { playNotificationSound } from '../InterveneDashboard/notificationSound.ts';

const Logo = process.env.REACT_APP_NODE_ENV === 'test' ? TestLogo : MachadaloLogoTop;
interface SettingOption {
  label: string;
  value: string;
  isVisible?: boolean;
  icon?: React.ReactNode;
}

const MachadaloHeader: React.FC = () => {
  const actions = ConstantActions();
  const loginActions = LoginActions();
  const { dispatch } = useWebSocketAiContext();
  const setLeadActions = useSetRecoilState(leadsActionSelector);
  const [unreadMessageCounts, setUnreadMessageCounts] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const hideHeader =
  location.pathname.startsWith('/r/student') ||
  location.pathname.startsWith('/r/machadalostudio/');
  const [logo, setLogo] = useState(Logo);
  const settingDrop: SettingOption[] = [
    {
      label: 'My Profile',
      value: '/r/management/profile',
      isVisible: actions?.userHasPermission([]),
      icon: <PersonIcon fontSize="small" />,
    },
    {
      label: 'Activity Logs',
      value: '/r/activity-logs',
      isVisible: actions?.userHasPermission([globalpermissions?.navBar?.menuActivityLogs]),
      icon: <HistoryIcon fontSize="small" />,
    },
    {
      label: 'View Logs',
      value: '/r/login-logs',
      isVisible: actions?.userHasPermission([globalpermissions?.navBar?.menuLoginLogs]),
      icon: <LoginIcon fontSize="small" />,
    },
    {
      label: 'Change Password',
      value: '/r/management/change-password',
      isVisible: actions?.userHasPermission([globalpermissions?.navBar?.menuChangePassword]),
      icon: <LockIcon fontSize="small" />,
    },
    {
      label: 'Account',
      value: '/r/management/account/edit',
      isVisible: actions?.userHasPermission([globalpermissions?.navBar?.menuProfileAccount]),
      icon: <AccountCircleIcon fontSize="small" />,
    },
    {
      label: 'Logout',
      value: '/#/logout',
      isVisible: true,
      icon: <LogoutIcon fontSize="small" />,
    },
  ];
  const [userInfo, setUserInfo] = useRecoilState(userInformationAtom);
  const ORGANISATION_ID = userInfo?.profile?.organisation?.organisation_id ?? '';
  const [anchorEl, setAnchorEl] = useState < null | HTMLElement > (null);
  const hideSidebar = location.pathname.startsWith('/r/test/');
  const isTestHeader = location.pathname.startsWith('/r/test/');
  const isShowHeader = location.pathname.startsWith('/r/test/result');

  const wsUrl = `${process.env.REACT_APP_WEBSOCKET_URL}/notifications/`

  const { status, message, sendMessage, disconnect } = useChatSocket({ url: wsUrl });

  useEffect(() => {
    if (status === 'Connected' && ORGANISATION_ID) {
      try {
        sendMessage({ type: 'register', organisation_id: ORGANISATION_ID, user_id: Number(userInfo?.id ?? 0) });
      } catch (err) {
        console.warn(err, 'error'); //get_notifications
      }
    }
  }, [status, ORGANISATION_ID]);

  const fetchUserInfo = async (userId) => {
    try {
      const userInfoResponse = await loginActions.userInformation(userId);
      if (userInfoResponse?.status === 200 && userInfoResponse?.data) {
        const userData = userInfoResponse.data;
        if (userData?.profile?.organisation)
          if (userData.profile) {
            const permissions = {};
            (userData.profile.general_user_permission || []).forEach(perm => {
              permissions[perm.name.toLowerCase()] = perm.is_allowed;
            });
            userData.profile.permissions = permissions;
          }
        localStorage.setItem('userInfo', JSON.stringify(userData));
        setUserInfo(userData); // Update Recoil state
      } else {
        console.error('Failed to fetch user info, status:', userInfoResponse?.status, 'data:', userInfoResponse?.data);
      }
    } catch (error) {
      console.error('Failed to fetch user info:', error);
    }
  };


  useEffect(() => {
    if (message?.notification_type === "unread_message_counts" && message?.data?.totalUnread) {
      setUnreadMessageCounts(message?.data);
    } else if (message?.notification_type === "new_leads" && message?.data) {
      const { lead_id, leads_form_id } = message.data;
      storeNotification(leads_form_id, lead_id);
      setLeadActions({ type: "add", payload: message?.data })
    } else if (message?.notification_type === "update_leads" && message?.data) {
      setLeadActions({ type: "update", payload: message?.data })
    } else if (message?.notification_type === "delete_leads" && message?.data) {
      setLeadActions({ type: "delete", payload: message?.data })
    } else if (message?.notification_type === "bulk_update_leads" && message?.data && Array.isArray(message?.data)) {
      setLeadActions({ type: "bulk_update", payload: message?.data })
    } else if (message?.notification_type === "ai_query_response") {
      dispatch({
        type: "AI_QUERY_RESPONSE",
        payload: message?.data ?? null,
      });
    }
    else if (message?.notification_type === "image_generation_completed") {
      dispatch({
        type: "IMAGE_GENERATION_COMPLETED",
        payload: message?.data ?? null,
      });
    }
    else if (message?.notification_type === "questions_generated") {
      dispatch({
        type: "QUESTIONS_GENERATED",
        payload: message?.data ?? null,
      })
    }
    else if (message?.notification_type === "permissions_updated") {
      fetchUserInfo(userInfo?.id);
    }
      else if (message?.notification_type === "new_user_message_initiated") {
        console.log("Playing notification sound for new user message", message);
         playNotificationSound();
      }
  }, [message]);

  useEffect(() => {
    try {
      const storedUserInfo = localStorage.getItem('userInfo');
      if (storedUserInfo) {
        const parsedUserInfo = JSON.parse(storedUserInfo);
        const localLogo = parsedUserInfo?.profile?.organisation?.logo_url;
        setLogo(localLogo || Logo);
      } else {
        setLogo(Logo);
      }
    } catch (err) {
      console.error('Failed to parse userInfo from localStorage', err);
      setLogo(Logo);
    }
  }, []);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

const unlockAudio = () => {
  const audio = new Audio();
  audio.play().catch(() => {});
  document.removeEventListener('click', unlockAudio);
};

useEffect(() => {
  document.addEventListener('click', unlockAudio);
  return () => {
    document.removeEventListener('click', unlockAudio);
  };
}, []);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  function redirect(page) {
    if (page.startsWith('/#/')) {
      window.location.href = page;
    } else {
      navigate(page);
    }
  }

  const dynamicLink = actions.getDynamicHomePageLink();

  if (hideHeader) {
    return <ModernSidebar />;
  }
  if (isTestHeader && !isShowHeader) {
    return (
      <AppBar
        position="sticky"
        sx={{
          backgroundColor: '#fff',
          color: '#000',
          width: '100%',
          boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
        }}
      >
        <Container maxWidth="xl">
          <Toolbar sx={{ justifyContent: 'space-between', px: 0, flexWrap: "wrap" }}>
            {/* Left Section: Logo */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box sx={{ width: "110px", height: "45px" }}>
                <img
                  src={logo || Logo}
                  alt="Logo"
                  style={{ cursor: "pointer", width: "100%", height: "100%" }}
                // onClick={() => redirect(dynamicLink)}
                />
              </Box>
            </Box>

            {/* Right Section: Text */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: { xs: "flex-end", sm: "flex-end" },
                textAlign: "right",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 600,
                  color: "#333",
                  fontSize: { xs: "12px", sm: "14px" },
                }}
              >
                Powered by Machadalo
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontStyle: "italic",
                  color: "#777",
                  fontSize: { xs: "11px", sm: "13px" },
                }}
              >
                Brand owned by Vijaikirti Technologies Pvt. Ltd
              </Typography>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    );
  }

  return (
    <>
      <AppBar
        sx={{
          position: { sm: "sticky", xs: "fixed" },
          backgroundColor: '#fff',
          color: '#000',
          width: '100%',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
          paddingLeft: { xs: '40px', sm: '40px', md: '63px' },
        }}
      >
        <Container maxWidth="xl">
          <Toolbar sx={{ justifyContent: 'space-between', px: 0 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flexWrap: 'wrap' }}>
              {/* Side navigation for larger screens */}
              {/* <SideNavBar /> */}
              <ModernSidebar />
              {/* Logo with responsive size */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: { xs: "7px", sm: 2 },
                  position: 'fixed',
                  ml: { xs: '5px', sm: '10px', md: '0px' },
                }}
              >
                <Box sx={{ width: "100px", height: "50px" }}>
                  <img
                    src={logo || Logo}
                    alt="Synergytop Logo"
                    style={{ cursor: "pointer", width: "100%", height: "100%" }}
                    onClick={() => redirect(dynamicLink)}
                  />
                </Box>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ mx: 2, height: 'auto', display: { xs: 'none', sm: 'block' } }}
                />
                <Box sx={{ display: { xs: 'flex', sm: 'flex' }, flexDirection: 'column' }}>
                  <Typography variant="body1" sx={{ fontSize: { xs: '10px', sm: '14px' }, fontWeight: 'bold', color: '#333' }}>
                    Powered by Machadalo
                  </Typography>
                  <Typography variant="body2" sx={{ fontStyle: 'italic', color: '#777', display: { xs: 'none', sm: 'block' } }}>
                    Brand owned by Vijaikirti Technologies Pvt. Ltd
                  </Typography>
                </Box>
              </Box>
            </Box>
            {actions?.userHasPermission([globalpermissions?.notificationIcon?.notificationIcon]) && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <IconButton
                aria-label={unreadMessageCounts?.totalUnread ?? 0}
                onClick={() => navigate('/r/intervene-dashboard')}
              >
                <Badge
                  color="secondary"
                  badgeContent={unreadMessageCounts?.totalUnread}
                  max={999}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                >
                  <NotificationsIcon />
                </Badge>
              </IconButton>
              {/* <Typography
                variant="body1"
                sx={{
                  mr: 2,
                  fontWeight: 'bold',
                  color: '#333',
                  display: { xs: 'none', md: 'block' },
                }}
              >
                Welcome {userInfo?.first_name || 'Guest'}!
              </Typography>
              <IconButton onClick={handleMenuOpen}>
                <Avatar sx={{ bgcolor: '#6071fb', color: 'white', width: 40, height: 40 }}>
                  {userInfo?.first_name
                    ? `${userInfo.first_name[0].toUpperCase()}${userInfo.last_name ? ' ' + userInfo.last_name[0].toUpperCase() : ''}`
                    : 'G'}
                </Avatar>
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                keepMounted
              >
                {settingDrop
                  ?.filter((item) => item?.isVisible)
                  .map((item, index) =>
                    item.label === 'Logout' ? (
                      <MenuItem sx={{
                        color: '#d32f2f',
                        '&:hover': {
                          backgroundColor: 'rgba(211, 47, 47, 0.08)',
                        },
                      }}
                        key={index} onClick={() => actions?.logout()}>
                        <ListItemIcon sx={{ color: '#d32f2f' }}>
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText primary={item?.label} />
                      </MenuItem>
                    ) : (
                      <MenuItem key={index} onClick={() => redirect(item?.value)}>
                        <ListItemIcon>
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText primary={item?.label} />

                      </MenuItem>
                    )
                  )}
              </Menu> */}
            </Box>
            )}
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
};

export default MachadaloHeader;
